import { lazy, Suspense, useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { ShopifyCartProvider } from './contexts/ShopifyCartContext';
import { initPerformanceOptimizations } from './utils/performance';
import './App.css';

// Lazy load the main component for better performance
const LandingPageBilingual = lazy(() => import('./LandingPageBilingual'));

// Lazy load Shopify components
const CartDrawer = lazy(() => import('./components/CartDrawer'));
const ProductShowcase = lazy(() => import('./components/ProductShowcase'));

// Loading component
const LoadingSpinner = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh',
    background: 'linear-gradient(135deg, #1976d2 0%, #5e35b1 50%, #e91e63 100%)'
  }}>
    <div className="spinner" />
  </div>
);

function App() {
  // Initialize performance optimizations
  useEffect(() => {
    initPerformanceOptimizations();
  }, []);
  
  // Get language from URL or default to Dutch
  const lang = window.location.pathname.includes('/en') ? 'en' : 'nl';
  
  return (
    <HelmetProvider>
      <ShopifyCartProvider>
        <Suspense fallback={<LoadingSpinner />}>
          {/* Shopping Cart Drawer */}
          <CartDrawer lang={lang} />
          
          {/* Main Landing Page Content */}
          <LandingPageBilingual />
          
          {/* New Shopify Product Showcase Section */}
          <ProductShowcase lang={lang} />
        </Suspense>
      </ShopifyCartProvider>
    </HelmetProvider>
  );
}

export default App;